import { render, staticRenderFns } from "./cider_table.vue?vue&type=template&id=2c39fc80&scoped=true"
import script from "./cider_table.vue?vue&type=script&lang=js"
export * from "./cider_table.vue?vue&type=script&lang=js"
import style0 from "./cider_table.vue?vue&type=style&index=0&id=2c39fc80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39fc80",
  null
  
)

export default component.exports